const markedActions = new Set();

export function markActionAsHandled({ type }) {
  return markedActions.add(type);
}

export function unmarkActionAsHandled({ type }) {
  return markedActions.delete(type);
}

export function isActionMarkedAsHandled({ type }) {
  return markedActions.has(type);
}
